import { Injectable } from '@angular/core';

import { TrailerModel, TrailerService as ApiTrailerService } from '@core/api';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { TrailerWithImagesModel } from '@core/api/model/trailerWithImagesModel';

@Injectable({
  providedIn: 'root'
})
export class TrailerService {

  constructor(
    private apiTrailerService: ApiTrailerService
  ) {}

  getAvailableTrailers(id: number): Observable<TrailerModel[]> {
    return this.apiTrailerService.trailerGet(
      new HttpParams()
        .set('status[0]', TrailerModel.StatusEnum.Available)
        .set('gas_station_id', String(id))
    )
      .pipe(map(res => res.data));
  }

  getTrailerById(id: number): Observable<TrailerWithImagesModel> {
    return this.apiTrailerService.trailerIdGet(id)
      .pipe(map(res => res.data));
  }

}
